import { Component, OnInit } from '@angular/core';
import { RenaultCarruselDTO } from '../../../models/renault-carrusel-dto';
import { CarruselService } from '../../../services/carrusel.service';
import { heightContentAnimation, visibleContentAnimation } from 'src/app/animations';

@Component({
  selector: 'app-carrusel',
  templateUrl: './carrusel.component.html',
  styleUrls: ['./carrusel.component.scss'],
  animations: [visibleContentAnimation, heightContentAnimation]
})
export class CarruselComponent implements OnInit {

  model: RenaultCarruselDTO[] = [];

  constructor(private service: CarruselService) { }

  ngOnInit(): void {
    this.service.getUserAvailableCarrusel().subscribe(resp => {
      this.model = resp;
    });
  }

}


